var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#E0E0E0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.232 1.22667L14.2242 8.66667C13.8779 9.17333 14.5438 9.78667 15.0233 9.36L19.9512 5.06667C20.0844 4.96 20.2708 5.04 20.2708 5.22667V18.64C20.2708 18.8267 20.0311 18.9067 19.9245 18.7733L5.00777 0.906667C4.5283 0.32 3.83574 0 3.06326 0H2.53052C1.14539 0 0 1.14667 0 2.56V21.44C0 22.8533 1.14539 24 2.55716 24C3.43618 24 4.26193 23.5467 4.7414 22.7733L9.74917 15.3333C10.0954 14.8267 9.42952 14.2133 8.95006 14.64L4.0222 18.9067C3.88901 19.0133 3.70255 18.9333 3.70255 18.7467V5.36C3.70255 5.17333 3.94229 5.09333 4.04883 5.22667L18.9656 23.0933C19.4451 23.68 20.1643 24 20.9101 24H21.4428C22.8546 24 24 22.8533 24 21.44V2.56C24 1.14667 22.8546 0 21.4428 0C20.5372 0 19.7114 0.453333 19.232 1.22667Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNear);
export default __webpack_public_path__ + "static/media/Near.f8bfe8b7f329b0d33ad50a09260d92c4.svg";
export { ForwardRef as ReactComponent };